import axios from "axios";
import React, {Component} from "react";
import Modal from "react-bootstrap/Modal";
import FeatherIcon from 'feather-icons-react';
import Select from 'react-select';
import { toast } from "react-toastify";

class   ShoolfeeFormtransport extends Component{

    state = {
        id : "",
        responsible: "",
        profile : "",
        classe : "",
        student : "",
        schoolfeecategory : "",
        account : "",
        month : null,
        pay_mount : null,
        remaining_amount : null,
        scolary_year : null,
        years : [],
        sectschoolfeecatstudcategories : [],
        error : "",

        isModal : false,
        isClick : false,
        sections : [],
        section :"",
        transports : [],
        transport :"",
        responsibles : [],
        students : [],
        months : [],
        schoolfeecategories : [],
        chartaccounts : [],
        sms : 1,
        price : 1,
        title : "",
    }
    


    handleInputChange = (select) => {
        this.setState({
            classe : select.value,
            students : select.value.students,
            student : "",
        });
        // this.students(select.value)
    }

    handleInputMax = (e) => {
        
        if(this.state.schoolfeecategory && e.target.value > 0 && e.target.value <= (this.state.month?.length || 1) * this.state.price)
        {
            this.setState({
                [e.target.name]: e.target.value
            });
        }
        else{
            this.setState({
                [e.target.name]: ""
            }); 
        } 
    }

    storeShoolfee = ( val = null) =>{
        this.setState({ isClick : true})
        var data = {
                userId: this.state.responsible,
                sectionclasseId : this.state.classe ? this.state.classe.id : this.props.classe.sectionclasse,
                studentId : this.state.student,
                sectionschoolfeecategoryId : this.state.schoolfeecategory,
                monthId : this.state.month ? [this.state.month] : null,
                pay_mount : this.state.pay_mount ? this.state.pay_mount : null,
                remaining_amount : this.state.remaining_amount ?  this.state.remaining_amount : 0,
                operation : this.state.id ? (val === 1 ? "Archiver" : "Editer" ) : "Ajouter",
            }

        var request = this.state.id ? axios.put('schoolfees/'+this.state.id, data) : axios.post('schoolfees', data);
        request.then((response) =>{
            this.setState({ isClick : false})
            this.props.showModal(1)
            toast(response?.data?.msg, { theme : "light", style : { backgroundColor : "blue", color : "white"}})
        }).catch((error) => {
            this.setState({
                isClick : false,
                error : error.response.data.msg
            })
            toast(error.response?.data?.msg, { theme : "light", style : { backgroundColor : "red", color : "white"}})
        })
    }

    async responsibles(){
        var request = await axios.get('users');
        if(request.status === 200)
            this.setState({responsibles : request.data})
    }

    async months(){
        var request = await axios.get('trimesters');
        if(request.status === 200)
            this.setState({months : request.data})
    }

    async schoolfeecategories(){
        var request = await axios.get('schoolfeecategories');
        if(request.status === 200)
            this.setState({
                schoolfeecategories : request.data
            })
    }

    async sections(){
        var request = await axios.get('sections');
        if(request.status === 200)
            this.setState({ sections : request.data })
    }

    async transports(){
        var request = await axios.get('transports');
        if(request.status === 200)
            this.setState({transports : request.data})
    }

    edit=()=>  {
        this.form()
        this.responsibles()
        this.sections()
        this.transports()
        this.months()
        this.schoolfeecategories()
    }

    form=()=>{
        this.setState({
            id : this.props.formData ? this.props.formData.id : "",
            responsible: this.props.formData ? this.props.formData.userId : "",
            section : this.props.formData ? this.props.formData.section ? this.props.formData.section.id  : "" : "",
            student : this.props.formData ?  this.props.formData.studentId : "",
            profile : this.props.formData ? this.props.formData.profile : "",
            account : this.props.formData ? this.props.formData.accountingbalance ? this.props.formData.accountingbalance.chartaccount_id : "" : "",
            month : this.props.formData ? this.props.formData.month ? this.props.formData.month.id : null : null,
            pay_mount : this.props.formData ? this.props.formData.pay_mount : null,
            remaining_amount : this.props.formData ? this.props.formData.remaining_amount : null,
            scolary_year : this.props.formData ? this.props.formData.yearId : null,
            title : this.props.formData && this.props.formData.id ? "Modifier le paiement "  : "Ajouter un paiement " ,
            error : "",
        })
    }

    showModal = () => {
        this.setState({
            isModal : !this.state.isModal,
        })
        this.responsibles();
        this.students()
        this.months()
        this.schoolfeecategories()
    }

    render(){
        var optiontransports = [], optionsectionclasses = [], optionresponsibles= [] , optionchartaccounts= [] , optionschoolfeecategories= [] , optionmonths = [], optionstudents= [];
        
        this.state.transports.map((transport) => {
            let count = 0
            this.state.schoolfeecategories.filter(dat => dat.id == this.props.schoolfeecategory.id).map((choolfeecategory) => {                
                count += choolfeecategory.sectionschoolfeecategories.filter(data =>data.transport.id == transport.id)?.length
            })
            
            if(count > 0)
                optiontransports.push({value : transport, label : transport.axe})
        });

        this.state.sections.map((section) => {
            section.sectionclasses.map((sectionclasse) =>{
                optionsectionclasses.push({value : sectionclasse, label : sectionclasse.class.short_entitled_class + " " + sectionclasse.title + " , " + section.short_entitled_section})
            })
        });
        
        (this.state.students ?? []).map((student) => {
            var user_id =  student.user.user.id;
            optionstudents.push({
                value : student.id, 
                label : student.matricule + " " + (student.user.last_name || "") + " " + (student.user.family_name || "") + "  " + (student.user.first_name || ""), user_id : user_id,
                sectschoolfeecatstudcategories : student.sectschoolfeecatstudcategories
            })
        })

        this.state.responsibles.map((responsible) => {
            var last_name = responsible.last_name ? (responsible.last_name || "") : "";
            var family_name = responsible.family_name ? (responsible.family_name || "") : "";
            var first_name = responsible.first_name ? (responsible.first_name || "") :"";
            var tel = responsible.tel ? responsible.tel : "";
            optionresponsibles.push({value : responsible.id, label :  last_name + "  "+  family_name + "  "+  first_name +" "+ tel})
        });

        this.state.months?.sort((a, b) => a.trimester?.short_trimester < b.trimester?.short_trimester ? -1 : 1).map((month) => {
            if(optionmonths?.filter(v => v.trimesterId == month.trimester?.id)?.length == 0)
                optionmonths.push({ value : month.id, trimesterId : month.trimester?.id, label : month.trimester?.short_trimester})
        })

        this.state.students?.length > 0 && (
            this.state.schoolfeecategories.filter(dat => dat.id == this.props.schoolfeecategory.id).map((choolfeecategory) => {
                
                return(
                    choolfeecategory.sectionschoolfeecategories.filter(data => this.state.transport && data.transport.id == this.state.transport.id).map((data) => {
                        var categorie = "", price = '' // data.price;
                        data.trimesectschools?.sort((a, b) => a.trimester?.short_trimester < b.trimester?.short_trimester ? -1 : 1).map((val_) => {
                            optionschoolfeecategories.push({ value : val_.id, trimesterId : val_.trimester?.id, label : choolfeecategory.category + " " + val_.trimester?.short_trimester + " "+val_.price + " "+data.currency + " " + categorie, price : val_.price > 0 ? val_.price : 0 })
                        })
                    })
                )
            })
        )

        return(
            <div>
            <Modal 
                show={this.props.isModal} 
                onHide={this.props.showModal}
                size="lg"
                onEntered={this.edit}
                backdrop={"static"}>
                <Modal.Header>
                    <Modal.Title className="h6 font-monospace">{ this.state.title}   <span className="text-primary">{ this.props.schoolfeecategory ? this.props.schoolfeecategory.category : "" } { this.state.price }{ this.props.schoolfeecategory ? this.props.schoolfeecategory.currency : "" } </span> </Modal.Title>
                </Modal.Header>
                    <Modal.Body className="row">
                        <div className="text-center"><span className="text-danger text-small">{ this.state.error }</span></div>
                        <div className="form-group col-md-6 mt-2">
                            <label className="font-monospace fw-normal">Axe Activité</label>
                            <Select
                                className="form-control form-control-sm p-0"
                                placeholder={this.state.transport && (this.state.transport.axe)}
                                value = {
                                    optiontransports.filter(option => 
                                        this.state.transport && option.value && option.value.id == this.state.transport.id)
                                }
                                defaultValue={this.state.transport}
                                onChange={
                                    (select) => {
                                        this.setState({
                                            transport : select.value
                                        });
                                    }
                                }
                                options={optiontransports}
                            />
                        </div>

                        <div className="form-group col-md-6 mt-2">
                            <label className="font-monospace fw-normal">Classe </label>
                            <Select
                                className="form-control form-control-sm p-0"
                                placeholder={ this.state.classe ?  this.state.classe.class ? this.state.classe.class.short_entitled_class + " " + this.state.classe.title :  "" : ""}
                                value = {
                                    optionsectionclasses.filter(option => 
                                        this.state.classe && option.value && option.value.id == this.state.classe.id)
                                }
                                defaultValue={this.state.classe}
                                onChange={
                                    this.handleInputChange
                                }
                                options={optionsectionclasses}
                            />
                        </div>

                        <div className="form-group col-md-6 mt-2">
                            <label className="font-monospace fw-normal">Paiement de l'élève</label>
                            <div className=" ">
                                <Select 
                                    className="form-control form-control-sm p-0"
                                    value = {
                                        optionstudents.filter(option => 
                                        option.value == this.state.student)
                                    }
                                    defaultValue={this.state.student}
                                    onChange={
                                        (select) => {
                                            this.setState({
                                                student : select.value,
                                                responsible : select.user_id,
                                                sectschoolfeecatstudcategories : select.sectschoolfeecatstudcategories,
                                                // schoolfeecategory : "",
                                            });
                                        }
                                    }
                                    options={optionstudents}
                                />
                            </div>
                        </div>

                        <div className={"form-group col-md-6 mt-2"}>
                            <label className="font-monospace fw-normal">Paiement</label>
                            <div className="">
                                <Select 
                                    className="form-control form-control-sm p-0"
                                    value = {
                                        optionschoolfeecategories.filter(option => 
                                        option.value == this.state.schoolfeecategory)
                                    }
                                    defaultValue={this.state.schoolfeecategory}
                                    onChange={
                                        (select) => {
                                            this.setState({
                                                schoolfeecategory : select.value, 
                                                price : select.price,
                                                month : optionmonths.filter(val => val.trimesterId == select.trimesterId)
                                            });
                                        }
                                    }
                                    options={optionschoolfeecategories}
                                />
                            </div>
                        </div>

                        <div className="form-group col-md-6 mt-2 d-none">
                            <label className="font-monospace fw-normal">Trimestre</label>
                            <div className=" ">
                            <Select
                                className="form-control form-control-sm p-0"
                                closeMenuOnSelect={false}
                                defaultValue={[ ]}
                                isMulti
                                options={optionmonths}
                                onChange={
                                    (select) => {
                                        this.setState({
                                            month : select
                                        });
                                    }
                                } 
                                />
                            </div>
                        </div>

                        <div className="col-md-6 mt-2 mt-2">
                            <div className="form-group has-icon-left">
                                <label htmlFor="nom-id-icon">Montant payé</label>
                                <div className="position-relative mt-1">
                                    <input type="number" className="form-control form-control-sm" placeholder=""  onChange={this.handleInputMax} name="pay_mount"  value={this.state.pay_mount} id="nom-id-icon" />
                                    <div className="form-control-icon">
                                        <FeatherIcon icon="trello"></FeatherIcon>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <button onClick={this.props.showModal} className="btn btn-outline-secondary btn-sm  p-0 px-1"><FeatherIcon icon="corner-down-left"></FeatherIcon> Fermer</button>
                        <button onClick={() => this.storeShoolfee()} disabled={ this.state.isClick } className="btn btn-sm btn-outline-primary  p-0 px-1"><FeatherIcon icon="check-square"></FeatherIcon> Sauvegarder</button>
                    </Modal.Footer>
            </Modal>
            

            {/* <ParentfamilyForm 
                isModal={this.state.isModal} 
                formData={{}} 
                showModal={this.showModal}
            /> */}
        </div>
        )
    }
}
export default ShoolfeeFormtransport;